import React from "react";
import { useTranslation } from "react-i18next";

//MUI
import Box from "@mui/material/Box";
import DialogActions from "@mui/material/DialogActions";
import Toolbar from "@mui/material/Toolbar";

//Custom Components
import useFormController from "@/components/useFormController";
import DynamicDialog from "@/ui/Dialog/DynamicDialog";
import DialogHeader from "@/ui/Dialog/DialogHeader";
import DialogToolbarHeading from "@/ui/Dialog/DialogToolbarHeading";
import DialogToolbarButtonClose from "@/ui/Dialog/ToolbarButtons/DialogToolbarButtonClose";
import ToolbarFillContent from "@/ui/Toolbar/ToolbarFillContent";
import DialogBody from "@/ui/Dialog/DialogBody";
import DialogActionButtonClose from "@/ui/Dialog/ActionButtons/DialogActionButtonClose";
import FormContent from "@/components/FormContent";

//Types
import { FormControllerProps } from "@/@types/components/formController";
import { IDialogProps } from "@/@types/ui/DialogContext";

function XMLDialog(props: IDialogProps) {
  const { t } = useTranslation();

  const { onClose, mode, form, dc, defaultValues } = props

  // FUNCTIONS
  // -------------------------------------------------------------------------------------------

  function handleClose() {
    onClose({ dataChanged: false, action: mode });
  }


  // RETURN
  // -------------------------------------------------------------------------------------------
  return (
    <DynamicDialog open={true}>
      <DialogHeader>
        <Toolbar variant="dense" disableGutters={true}>
          <DialogToolbarHeading>{t("common.xml")}</DialogToolbarHeading>
          <ToolbarFillContent />
          <DialogToolbarButtonClose onClick={handleClose} />
        </Toolbar>
      </DialogHeader>
      <DialogBody>
        <Box m={2}>
          <FormContent
            fieldNames={dc.getFormFieldsNames(form)}
            record={defaultValues}
            fields={dc.getFormFields(form)}
            mode={mode}
            columns={1}
          />
        </Box>
      </DialogBody>
      <DialogActions>
        <DialogActionButtonClose variant="contained" onClick={handleClose} />
      </DialogActions>
    </DynamicDialog>
  )
}

export default XMLDialog